import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { LogoMark, WhatsAppIcon } from "./Logo";
import { BRAND, waLink, mailLink, telLink } from "../lib/brand";

export const Contact = () => {
  const year = new Date().getFullYear();
  return (
    <footer id="contact" data-testid="contact" className="relative bg-[#131311] text-[#faf9f5] lj-grain overflow-hidden">
      <div className="pointer-events-none absolute -bottom-32 left-1/2 -translate-x-1/2 h-[500px] w-[800px] rounded-full bg-[radial-gradient(circle,rgba(197,160,89,0.14),transparent_65%)]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 relative">
        <div className="py-16 sm:py-24 lg:py-32 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-xs tracking-[0.34em] uppercase text-[#c5a059] font-semibold">
              Let's Talk
            </span>
            <h2 className="mt-6 font-serif text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tight leading-[1]">
              Let's discuss your
              <br />
              <span className="italic text-gold-gradient">real estate goals in Hisar.</span>
            </h2>

            <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href={waLink("Hello Laxmi Jiwan Properties, I'd like to discuss my property requirement in Hisar.")}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 rounded-full bg-[#25d366] text-white px-8 py-4 text-sm font-semibold shadow-[0_14px_34px_rgba(37,211,102,0.3)] hover:bg-[#1eae53] transition-all duration-300 hover:-translate-y-0.5"
                data-testid="contact-whatsapp-main-button"
              >
                <WhatsAppIcon className="h-5 w-5" /> {BRAND.phoneDisplay}
              </a>
              <a
                href={mailLink()}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 rounded-full border border-[#c5a059] text-[#faf3e0] px-8 py-4 text-sm font-semibold hover:bg-[#c5a059] hover:text-[#131311] transition-all duration-300"
                data-testid="contact-email-main-button"
              >
                <Mail className="h-5 w-5" /> Email Us
              </a>
              <a
                href={telLink}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 rounded-full border border-[#3a382f] text-[#faf9f5] px-8 py-4 text-sm font-semibold hover:border-[#faf9f5] transition-all duration-300"
                data-testid="contact-phone-main-button"
              >
                <Phone className="h-5 w-5" /> Call Now
              </a>
            </div>

            <p className="mt-8 text-sm text-[#c9c4b6]">{BRAND.hours}</p>
          </motion.div>
        </div>

        <div className="border-t border-[#2e2c26] py-10 flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex items-center gap-3">
            <LogoMark className="h-9 w-9" />
            <div className="leading-none">
              <div className="font-serif text-lg font-semibold text-[#faf3e0]">
                Laxmi Jiwan Properties
              </div>
              <div className="text-[10px] tracking-[0.34em] uppercase text-[#8a8578] mt-1">
                {BRAND.tagline}
              </div>
            </div>
          </div>

          <div className="flex flex-col md:items-start gap-1 text-sm text-[#c9c4b6] md:pl-6 md:border-l md:border-[#2e2c26]">
            <a href={mailLink()} className="lj-underline-link hover:text-[#faf3e0]">
              {BRAND.email}
            </a>
            <span>{BRAND.address}</span>
          </div>
        </div>

        <div className="pb-28 sm:pb-8 text-center text-xs text-[#8a8578] space-y-1 flex flex-col items-center" data-testid="footer-bottom">
          <div>© {year} Laxmi Jiwan Properties, Hisar · Haryana. All rights reserved.</div>
          <div data-testid="footer-credit">
            Website and IT services by{" "}
            <span className="text-[#a89a76]">Aither Digital Co</span>,{" "}
            <a href="tel:+919999020008" className="lj-underline-link hover:text-[#c9c4b6]">
              +91 99990 20008
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
